export enum FontSize {
  XLarge = 'fs-1', // bem grande
  Large = 'fs-2',
  Medium = 'fs-3',
  Normal = 'fs-4',
  Small = 'fs-5',
  XSmall = 'fs-6', // menorzinho
}

// Ícones do sistema: traço Lucide (ISC, ver public/media/icons/lucide/LICENSE), cor por
// `currentColor` — herdam a cor do container, sem cor fixa fora da paleta da marca (BRAND.md).
// Renderize com `<KTSVG path={IconPaths.…} />`; ícone novo entra aqui, não como caminho solto.
export enum IconPaths {
  Add = '/media/icons/lucide/plus.svg',
  // "−" par do Add (toggle +/−).
  Remove = '/media/icons/lucide/minus.svg',
  NewFile = '/media/icons/lucide/file-plus.svg',
  Search = '/media/icons/lucide/search.svg',
  Pdf = '/media/icons/lucide/file-text.svg',
  Csv = '/media/icons/lucide/file-spreadsheet.svg',
  Close = '/media/icons/lucide/x.svg',
  Trash = '/media/icons/lucide/trash-2.svg',
  Gear = '/media/icons/lucide/settings.svg',
  Key = '/media/icons/lucide/key-round.svg',
  Arrow = '/media/icons/lucide/chevron-down.svg',
  CloudDownload = '/media/icons/lucide/cloud-download.svg',
  Download = '/media/icons/lucide/download.svg',
  ArrowDown = '/media/icons/lucide/chevron-down.svg',
  ArrowRight = '/media/icons/lucide/chevron-right.svg',
  ArrowLeft = '/media/icons/lucide/chevron-left.svg',
  ArrowUp = '/media/icons/lucide/chevron-up.svg',
  Record = '/media/icons/lucide/video.svg',
  Sms = '/media/icons/lucide/message-square-text.svg',
  Copy = '/media/icons/lucide/copy.svg',
  Info = '/media/icons/lucide/info.svg',
  // "!" num círculo (par do Info): erro/alerta, ex. estado de erro da tabela.
  Alert = '/media/icons/lucide/circle-alert.svg',
  Email = '/media/icons/lucide/mail.svg',
  Delete = '/media/icons/lucide/trash-2.svg',
  Pen = '/media/icons/lucide/pencil.svg',
  Profile = '/media/icons/lucide/user.svg',
  Check = '/media/icons/lucide/check.svg',
  X = '/media/icons/lucide/circle-x.svg',
  Estetoscopio = '/media/icons/lucide/stethoscope.svg',
  File = '/media/icons/lucide/file-text.svg',
  // Documento com check (termo/consentimento).
  Termo = '/media/icons/lucide/file-check.svg',
  Sun = '/media/icons/lucide/sun.svg',
  Moon = '/media/icons/lucide/moon.svg',
  System = '/media/icons/lucide/monitor-cog.svg',
  Logout = '/media/icons/lucide/log-out.svg',
  Eye = '/media/icons/lucide/eye.svg',
  Imagem = '/media/icons/lucide/image.svg',
  EyeSlash = '/media/icons/lucide/eye-off.svg',
  Pip = '/media/icons/lucide/picture-in-picture-2.svg',
  Refresh = '/media/icons/lucide/refresh-cw.svg',
  Hamburguer = '/media/icons/lucide/menu.svg',
  FullScreen = '/media/icons/lucide/maximize.svg',
  Maleta = '/media/icons/lucide/briefcase-medical.svg',
  Notas = '/media/icons/lucide/notebook-pen.svg',
  Play = '/media/icons/lucide/play.svg',
  Pause = '/media/icons/lucide/pause.svg',
  DotsHorizontal = '/media/icons/lucide/ellipsis.svg',
  XMark = '/media/icons/lucide/x.svg',
  // Funil de filtro (ex.: botão "Filtro" de mais filtros na listagem).
  Filter = '/media/icons/lucide/filter.svg',
  Bell = '/media/icons/lucide/bell.svg',
  // Estados do atendimento (traço `currentColor`, base Lucide): cards de estado da listagem.
  AtendimentoAguardando = '/media/icons/duotune/custom/atendimento-aguardando.svg',
  AtendimentoEmAtendimento = '/media/icons/duotune/custom/atendimento-em-atendimento.svg',
  AtendimentoPendencia = '/media/icons/duotune/custom/atendimento-pendencia.svg',
  AtendimentoPendenciaResolvida = '/media/icons/duotune/custom/atendimento-pendencia-resolvida.svg',
  AtendimentoFinalizado = '/media/icons/duotune/custom/atendimento-finalizado.svg',
  AtendimentoCancelado = '/media/icons/duotune/custom/atendimento-cancelado.svg',
  AtendimentoNaoCompareceu = '/media/icons/duotune/custom/atendimento-nao-compareceu.svg',
  Suporte = '/media/icons/duotune/custom/suporte.svg',
  // Selos legais da prescrição: controle especial e retenção/validade.
  Escudo = '/media/icons/lucide/shield-alert.svg',
  Relogio = '/media/icons/lucide/clock.svg',
  // Com `InlineSvg`, não `KTSVG`: o `.svg-icon` fixaria tamanho e cor.
  CorteDiagonal = '/media/icons/duotune/custom/corte-diagonal.svg',
  // Ícones que antes vinham de Bootstrap Icons / Font Awesome ou de caminhos soltos no código.
  Warning = '/media/icons/lucide/triangle-alert.svg',
  CircleCheck = '/media/icons/lucide/circle-check.svg',
  CircleMinus = '/media/icons/lucide/circle-minus.svg',
  CircleSlash = '/media/icons/lucide/circle-slash.svg',
  Help = '/media/icons/lucide/circle-help.svg',
  OctagonX = '/media/icons/lucide/octagon-x.svg',
  CalendarX = '/media/icons/lucide/calendar-x.svg',
  Pill = '/media/icons/lucide/pill.svg',
  ShieldCheck = '/media/icons/lucide/shield-check.svg',
  History = '/media/icons/lucide/history.svg',
  Bot = '/media/icons/lucide/bot.svg',
  Magic = '/media/icons/lucide/wand-sparkles.svg',
}

// Classes de ícones da fonte Bootstrap Icons (bi-*), para uso com IconChip
// e outros elementos que renderizam ícones via classe CSS em vez de SVG.
export enum IconClass {
  FileText = 'bi-file-earmark-text',
  TextParagraph = 'bi-text-paragraph',
  CheckCircle = 'bi-check-circle',
  Numeric = 'bi-123',
  ListCheck = 'bi-list-check',
  Pen = 'bi-pen',
  PersonCheck = 'bi-person-check',
  GripVertical = 'bi-grip-vertical',
  PlusLg = 'bi-plus-lg',
  UiChecksGrid = 'bi-ui-checks-grid',
  // Formas da classificação de risco da triagem: um formato por nível, para não depender da cor.
  CircleFill = 'bi-circle-fill',
  DiamondFill = 'bi-diamond-fill',
  TriangleFill = 'bi-triangle-fill',
  SquareFill = 'bi-square-fill',
  Lock = 'bi-lock',
}

export enum MenuPaths {
  Inicio = '/media/icons/menu/inicio.svg',
  Atendimento = '/media/icons/menu/atendimento.svg',
  Avaliacoes = '/media/icons/menu/avaliacoes.svg',
  Pacientes = '/media/icons/menu/pacientes.svg',
  Saude_Ocupacional = '/media/icons/menu/saude-ocupacional.svg',
  Financeiro = '/media/icons/menu/financeiro.svg',
  Relatorios = '/media/icons/menu/relatorios.svg',
  Cadastros = '/media/icons/menu/cadastros.svg',
  Administracao = '/media/icons/menu/administracao.svg',
  Cadastros_Globais = '/media/icons/menu/cadastros-globais.svg',
  Esus = '/media/icons/menu/esus.svg',
  Api = '/media/icons/menu/api.svg',
  Sair = '/media/icons/menu/sair.svg',
  Chevron = '/media/icons/menu/chevron.svg',
  Menu = '/media/icons/menu/menu.svg',
  Busca = '/media/icons/menu/busca.svg',
  Editar_Perfil = '/media/icons/menu/editar-perfil.svg',
}

export enum ModalSize {
  Small = 'modal-sm',
  Medium = 'modal-md',
  Large = 'modal-lg',
  ExtraLarge = 'modal-xl',
}

export enum IconSize {
  ExtraSmall = 'svg-icon-1x',
  Small = 'svg-icon-2x',
  Medium = 'svg-icon-3x',
  Large = 'svg-icon-4x',
  ExtraLarge = 'svg-icon-5x',
}

export enum ButtonType {
  Submit = 'submit',
  Reset = 'reset',
  Button = 'button',
}

export enum GridCols {
  One = 'col-lg-12 col-md-12',
  Two = 'col-lg-6 col-md-12',
  Three = 'col-lg-4 col-md-12',
  Four = 'col-lg-3 col-md-12',
  Six = 'col-lg-2 col-md-12',
}

export enum MaskType {
  Phone = 'phone',
  CpfCns = 'cpf_cns',
  CPF = 'cpf',
  CNPJ = 'cnpj',
  CEP = 'cep',
  CNS = 'cns',
  CNES = 'cnes',
  CAEPF = 'caepf',
  CRM = 'crm',
  RQE = 'rqe',
  RG = 'rg',
  CTPS_Numero = 'ctps_numero',
  CTPS_Serie = 'ctps_serie',
  Matricula = 'matricula',
  Custom = 'custom',
}

export enum ControlError {
  ModalCancelled = 'MODAL_CANCELLED',
  Timeout = 'TIMEOUT',
  InvalidState = 'INVALID_STATE',
  InvalidPassword = 'Senha inválida para o certificado digital',
}

/** Onde o vídeo da teleconsulta está sendo exibido (LO-829). */
export enum LocalVideoChamada {
  Tela = 'TELA',
  Pip = 'PIP',
  Mini = 'MINI',
}

/**
 * Como a janela PiP da teleconsulta foi aberta (LO-829). O Chrome fecha sozinho a aberta automaticamente
 * quando o usuário volta à aba — esse fechamento não é pedido do médico e não pode tirá-lo da chamada.
 */
export enum OrigemPipChamada {
  Gesto = 'GESTO',
  Automatico = 'AUTOMATICO',
}
